<div class="container py-5">
  <div class="row justify-content-center">
    <div class="col-lg-8 col-md-10">

      <div class="card shadow-lg border-0 rounded-4">
        <div class="card-body p-4">

          <h3 class="heading text-center mb-4 text-primary">Job Application Form</h3>

          <form [formGroup]="applyForm" (ngSubmit)="onSubmit()">

            <!-- Name & Email -->
            <div class="row g-3">
<div class="col-md-6">

  <mat-form-field appearance="outline" class="w-100 compact-field">
    
    <mat-label>Full Name</mat-label>

    <input
      matInput
      type="text"
      formControlName="candidateName"
      (keydown)="blockScriptKeys($event)"
      (paste)="blockPaste($event)"
      minlength="3"
      maxlength="50"
      (keydown)="allowOnlyLetters($event)"
  (paste)="blocknumPaste($event)"
    />

    <!-- Errors -->
    <mat-error *ngIf="f['candidateName'].touched && f['candidateName'].errors">

      <span *ngIf="f['candidateName'].errors['required']">
        Full name is required
      </span>
      <span *ngIf="f['candidateName'].errors?.['pattern']">
  Only alphabets are allowed (no numbers or special characters)
</span>

      <span *ngIf="f['candidateName'].errors['minlength']">
        Name must be at least 3 characters long
      </span>

      <span *ngIf="f['candidateName'].errors['maxlength']">
        Name must be at most 50 characters long
      </span>

    </mat-error>

  </mat-form-field>

</div>

<div class="col-md-6">

  <mat-form-field appearance="outline" class="w-100">

    <mat-label>Email</mat-label>

    <input
      matInput
      type="email"
      formControlName="email"
      (keydown)="blockScriptKeys($event)"
      (paste)="blockPaste($event)"
    />

    <!-- Errors -->
    <mat-error *ngIf="f['email'].touched && f['email'].errors">

      <span *ngIf="f['email'].errors['required']">
        Email is required
      </span>

      <span *ngIf="f['email'].errors['email']">
        Invalid email format
      </span>

      <span *ngIf="f['email'].errors?.['pattern']">
  Email does not match required pattern
</span>

    </mat-error>

  </mat-form-field>

</div>
            </div>

            <!-- Phone & State -->
            <div class="row g-3 mt-1">
<div class="col-md-6">

  <mat-form-field appearance="outline" class="w-100">

    <mat-label>Phone</mat-label>

    <input
      matInput
      type="text"
      formControlName="phone"
      (keydown)="blockScriptKeysphone($event)"
      (paste)="blockPastephone($event)"
      minlength="10"
      maxlength="10"
    />

    <!-- Errors -->
    <mat-error *ngIf="f['phone'].touched && f['phone'].errors">

      <span *ngIf="f['phone'].errors['required']">
        Phone is required
      </span>

      <span *ngIf="f['phone'].errors['pattern']">
        Enter valid phone number
      </span>

      <span *ngIf="f['phone'].errors['minlength']">
        Phone must be 10 characters long
      </span>

      <span *ngIf="f['phone'].errors['maxlength']">
        Phone must be 10 characters long
      </span>

    </mat-error>

  </mat-form-field>

</div>

<div class="col-md-6">

<!-- <mat-form-field appearance="outline" class="w-100">
  <mat-label>State</mat-label>

  <mat-select formControlName="state"  (selectionChange)="onStateChange($event.value)">


    <mat-option>
      <ngx-mat-select-search
        [formControl]="stateFilterCtrl"
        
        placeholderLabel="Search state..."
        noEntriesFoundLabel="No state found">
      </ngx-mat-select-search>
    </mat-option>


    <mat-option *ngFor="let state of filteredStates" [value]="state.stateName">
      {{ state.stateName }}
    </mat-option>

  </mat-select>

  <mat-error *ngIf="f['state'].touched && f['state'].errors?.['required']">
    State is required
  </mat-error>

</mat-form-field> -->

<mat-form-field appearance="outline" class="w-100">
  <mat-label>State</mat-label>

  <mat-select
    formControlName="state"
    [disabled]="true"
  >

    <mat-option value="Andhra Pradesh">
      Andhra Pradesh
    </mat-option>

  </mat-select>

  <mat-error
    *ngIf="f['state'].touched && f['state'].errors?.['required']"
  >
    State is required
  </mat-error>

</mat-form-field>

</div>
</div>

            <!-- District & Constituency -->
            <div class="row g-3 mt-1">
<div class="col-md-6">

<mat-form-field appearance="outline" class="w-100">
  <mat-label>District</mat-label>

  <mat-select formControlName="district" (selectionChange)="onDistrictChange($event.value)" panelClass="district-panel">

    <!-- SEARCH -->
    <mat-option>
      <ngx-mat-select-search
        [formControl]="districtFilterCtrl"
        placeholderLabel="Search district..."
        noEntriesFoundLabel="No district found">
      </ngx-mat-select-search>
    </mat-option>

    

    <mat-option *ngFor="let d of filteredDistricts" [value]="d.name">
      {{ d.name }}
    </mat-option>

  </mat-select>

  <mat-error *ngIf="f['district'].touched && f['district'].errors?.['required']">
    District is required
  </mat-error>
</mat-form-field>

</div>

<div class="col-md-6">

<mat-form-field appearance="outline" class="w-100">
  <mat-label>Constituency</mat-label>

  <mat-select formControlName="constituency">

    <!-- 🟢 SEARCH (only when district selected) -->
    <mat-option *ngIf="f['district'].value">
      <ngx-mat-select-search
        [formControl]="constituencyFilterCtrl"
        placeholderLabel="Search constituency..."
        noEntriesFoundLabel="No constituency found">
      </ngx-mat-select-search>
    </mat-option>

        <!-- 🔴 When district not selected -->
    <mat-option *ngIf="!f['district'].value" disabled>
      Please select District first
    </mat-option>

    <mat-option *ngFor="let c of filteredConstituencies" [value]="c">
      {{ c }}
    </mat-option>

  </mat-select>

  <mat-error *ngIf="f['constituency'].touched && f['constituency'].errors?.['required']">
    Constituency is required
  </mat-error>
</mat-form-field>

</div>
            </div>

            <!-- Role & Experience -->
            <div class="row g-3 mt-1">
<div class="col-md-6">

  <mat-form-field appearance="outline" class="w-100">

    <mat-label>Applied Role</mat-label>

    <mat-select formControlName="appliedRole">

       <mat-option value="">
      Select
    </mat-option>

      <mat-option *ngFor="let job of jobs" [value]="job.id">
        {{ job.title  }}
      </mat-option>

    </mat-select>

    <mat-error *ngIf="f['appliedRole'].touched && f['appliedRole'].errors?.['required']">
      Applied Role is required
    </mat-error>

  </mat-form-field>

</div>

<div class="col-md-6">

  <mat-form-field appearance="outline" class="w-100">

    <mat-label>Years of Experience</mat-label>

    <mat-select formControlName="yearsOfExperience">

      <mat-option *ngFor="let exp of experienceList" [value]="exp">
        {{ exp }} Years
      </mat-option>

    </mat-select>

    <mat-error *ngIf="(f['yearsOfExperience'].touched || submitted) && f['yearsOfExperience'].errors?.['required']">
      Experience is required
    </mat-error>

  </mat-form-field>

</div>

<div class="col-md-6">

  <mat-form-field appearance="outline" class="w-100">

    <mat-label>Reference Name / Student ID</mat-label>

    <input
      matInput
      type="text"
      formControlName="reference"
      placeholder="Enter reference name or student ID"
      (keydown)="blockScriptKeys($event)"
      (paste)="blockPaste($event)"
      minlength="3"
      maxlength="50"
    />

    <!-- Errors -->
    <mat-error *ngIf="f['reference'].touched && f['reference'].errors">

      <span *ngIf="f['reference'].errors['pattern']">
        Only letters and numbers are allowed
      </span>

      <span *ngIf="f['reference'].errors['minlength']">
        Minimum 3 characters required
      </span>

      <span *ngIf="f['reference'].errors['maxlength']">
        Maximum 50 characters allowed
      </span>

    </mat-error>

  </mat-form-field>

</div>
            </div>

            <!-- Resume -->
<div class="mt-3">
  <label class="form-label d-flex align-items-center gap-2">
    Resume Content <span>*</span>

<i
  class="bi bi-info-circle-fill"
  matTooltip="Paste or write your resume content here"
  matTooltipPosition="right"
  style="cursor: pointer; font-size: 18px; color: #6c757d;">
</i>
  </label>

<textarea
  rows="4"
  class="form-control form-area"
  formControlName="resumeContent"
  (keydown)="blockScriptKeys($event)"
  (paste)="blockPaste($event)"></textarea>

  <small class="error" *ngIf="f['resumeContent'].touched && f['resumeContent'].errors">
    <span *ngIf="f['resumeContent'].errors['required']">
      Resume content is required
    </span>

    <span *ngIf="f['resumeContent'].errors['minlength']">
      Minimum 200 characters required
    </span>

    <span *ngIf="f['resumeContent'].errors['maxlength']">
      Maximum 10000 characters allowed
    </span>
  </small>
</div>

            <!-- Submit -->
            <div class="d-grid mt-4">
              <button class="apply-btn btn btn-primary btn-lg mx-auto" type="submit" [disabled]="submitted">
                Submit Application
              </button>
            </div>

          </form>

        </div>
      </div>

    </div>
  </div>
</div>